var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "wkb-sig-chain-run" }, [
    _c("header", { staticClass: "wkb-sig-chain-run-head" }, [
      _c("h3", { staticClass: "wkb-sig-chain-run-title" }, [
        _vm._v(_vm._s(_vm.runHeadline)),
      ]),
      _vm.startedLabel
        ? _c("span", { staticClass: "wkb-sig-chain-run-meta" }, [
            _vm._v(_vm._s(_vm.startedLabel)),
          ])
        : _vm._e(),
    ]),
    _vm.showRunContext
      ? _c("div", { staticClass: "wkb-sig-chain-run-context" }, [
          _c("div", { staticClass: "wkb-sig-chain-selected-set" }, [
            _c("div", { staticClass: "wkb-sig-chain-selected-set-head" }, [
              _c("strong", [_vm._v("Selected nodes used")]),
              _c("span", { staticClass: "wkb-sig-chain-run-meta" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.selectedNodes.length) +
                    " node" +
                    _vm._s(_vm.selectedNodes.length === 1 ? "" : "s") +
                    " "
                ),
              ]),
            ]),
            _vm.selectedNodes.length
              ? _c(
                  "div",
                  { staticClass: "wkb-sig-chain-chip-list" },
                  _vm._l(_vm.selectedNodes, function (node) {
                    return _c(
                      "span",
                      { key: node.id, staticClass: "wkb-sig-chain-chip" },
                      [_vm._v(" " + _vm._s(node.label || node.id) + " ")]
                    )
                  }),
                  0
                )
              : _c("p", { staticClass: "wkb-inspector-note" }, [
                  _vm._v(
                    " No selected-node snapshot was recorded for this run. "
                  ),
                ]),
          ]),
          _vm.showPromptAccordion
            ? _c(
                "details",
                { staticClass: "wkb-sig-chain-prompt" },
                [
                  _c("summary", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.run.status === "loading"
                            ? "See prompt"
                            : "See LLM prompt and response"
                        ) +
                        " "
                    ),
                  ]),
                  _vm.run.status === "loading"
                    ? _c("div", { staticClass: "wkb-sig-chain-prompt-block" }, [
                        _c("strong", [_vm._v("Prompt")]),
                        _c("pre", { staticClass: "wkb-sig-chain-prompt-pre" }, [
                          _vm._v(_vm._s(_vm.run.promptPreview || "")),
                        ]),
                      ])
                    : [
                        _c("p", { staticClass: "wkb-inspector-note" }, [
                          _c("strong", [_vm._v("LLM status:")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.llmDebug.attempted
                                  ? "LLM prioritization was attempted."
                                  : _vm.llmDebug.reason ||
                                      "LLM prioritization was not run."
                              ) +
                              " "
                          ),
                        ]),
                        _vm.llmDebug.model
                          ? _c("p", { staticClass: "wkb-inspector-note" }, [
                              _c("strong", [_vm._v("Model:")]),
                              _vm._v(" " + _vm._s(_vm.llmDebug.model) + " "),
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "wkb-sig-chain-prompt-block" },
                          [
                            _c("strong", [_vm._v("Prompt")]),
                            _c(
                              "pre",
                              { staticClass: "wkb-sig-chain-prompt-pre" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.llmDebug.prompt &&
                                      Object.keys(_vm.llmDebug.prompt).length
                                      ? JSON.stringify(
                                          _vm.llmDebug.prompt,
                                          null,
                                          2
                                        )
                                      : "(no LLM prompt was sent for this run)"
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "wkb-sig-chain-prompt-block" },
                          [
                            _c("strong", [_vm._v("Response")]),
                            _c(
                              "pre",
                              { staticClass: "wkb-sig-chain-prompt-pre" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.llmDebug.response_text ||
                                      "(no response text returned)"
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                ],
                2
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.run.status === "error"
      ? _c(
          "div",
          { staticClass: "wkb-sig-chain-error", attrs: { role: "alert" } },
          [
            _vm._v(
              " " + _vm._s(_vm.run.error || "Could not rank connections.") + " "
            ),
          ]
        )
      : _vm.run.status === "success" && !_vm.chains.length
      ? _c("div", { staticClass: "wkb-sig-chain-empty" }, [
          _c("h4", [_vm._v("No connections ranked yet")]),
          _c("p", { staticClass: "wkb-inspector-note" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.payload.zero_state_reason ||
                    "No gene → mechanism → trait connection could be formed from the current graph."
                ) +
                " "
            ),
          ]),
        ])
      : _vm.run.status === "success" && _vm.chains.length
      ? _c(
          "div",
          { staticClass: "wkb-sig-chain-pathway-list" },
          _vm._l(_vm.chains, function (chain, index) {
            return _c("WorkspaceSigChainPathwayCard", {
              key: `${_vm.run.id}:${
                chain.chain_id || chain.title || "pathway"
              }:${index}`,
              attrs: {
                chain: chain,
                "graph-nodes": _vm.run.graphNodes || [],
                "graph-edges": _vm.run.graphEdges || [],
                "anchor-items": _vm.anchorItems,
                "selected-node-objects": _vm.selectedNodes,
                "selected-node-ids": _vm.selectedNodeIds,
                "session-context": _vm.sessionContext,
                "api-client": _vm.apiClient,
                "llm-available": _vm.llmAvailable,
                "saved-pathway-state": _vm.pathwayStateForChain(chain),
              },
              on: { "pathway-state-update": _vm.onPathwayStateUpdate },
            })
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }